<template>
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="tabGrid"
      :dataset="'ds0'"
      :columns="gridColumnsTab"
      :showDisplayCountControl="false"
    />
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMU_00007_T05', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    componentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      gridColumnsTab: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'pageTypeName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_PAGE_ID'),
        datafield: 'pageId',
      }, {
        text: this.$t('MSG_TXT_PAGE_NM'),
        datafield: 'pageName',
      }, {
        text: this.$t('MSG_TXT_STT'),
        datafield: 'pageStatusName',
        width: 100,
      }],
      localdata4: [],
    };
  },
  watch: {
    componentId() {
      if (this.componentId) {
        this.selectComponentPages();
      } else {
        this.tabGridClear();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.componentId) {
        this.selectComponentPages();
      }
    });
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata4',
    datafields: [
      { type: 'string', name: 'pageId', map: 'pageId' },
      { type: 'string', name: 'pageName', map: 'pageName' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'pageTypeCode', map: 'pageTypeCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'pageStatusCode', map: 'pageStatusCode' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'pageTypeName', map: 'pageTypeName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'pageStatusName', map: 'pageStatusName' },
    ],
  }],
  methods: {
    selectComponentPages() {
      // 선택한 데이터서비스 등록페이지 목록 조회
      http.request(this.pageId, 'DTS_CMU_00036', {
        path: {
          'component-id': this.componentId,
        },
      }).then(res => {
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    tabGridClear() {
      this.ds0.setRawData([]);
    },
  },
};
</script>
<style scoped>
</style>
